import { inject, Injectable, signal } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { firstValueFrom } from 'rxjs';

import { LayerBloc } from '@connect-services/client/blocs/layer.bloc';
import { LayersService, UpdateLayerDto } from '@connect-services/client/sdk/api';
import { HomeService } from '@connect-services/client/services/home.service';
import { LayerService } from '@connect-services/client/services/layer.service';
import { MapSourceService } from '@connect-services/client/services/map-source.service';
import { SnackBarService } from '@shared/client/services/snack-bar.service';

@Injectable({
    providedIn: 'root',
})
export class LayerEditService {
    public static maxRange = 10;
    public static minRange = 1;
    public readonly isEditing = signal(false);
    public readonly isEditingSymbology = signal(false);

    private readonly activatedRoute = inject(ActivatedRoute);
    private readonly homeService = inject(HomeService);
    private readonly layerBloc = inject(LayerBloc);
    private readonly layerService = inject(LayerService);
    private readonly layersServiceSdk = inject(LayersService);
    private readonly mapSourceService = inject(MapSourceService);
    private readonly router = inject(Router);
    private readonly snackBarService = inject(SnackBarService);

    public async editLayer(layerId: string, editedLayer: UpdateLayerDto): Promise<void> {
        try {
            await firstValueFrom(
                this.layersServiceSdk.layerControllerPatch({
                    id: layerId,
                    updateLayerDto: editedLayer,
                }),
            );

            if (this.layerBloc.value()?.id === layerId) {
                await this.layerBloc.load({ id: layerId }, { refresh: true });
            }

            this.snackBarService.openSuccessSnackBar('modificationsSaveSuccess');
            this.isEditing.set(false);
            this.layerService.forceLayerListRefresh.set(this.layerService.forceLayerListRefresh() + 1);
            await this.homeService.initSources();
            await this.mapSourceService.redrawSources();
            await this.router.navigate([], { relativeTo: this.activatedRoute });
        } catch {
            this.snackBarService.openErrorSnackBar('modificationsSaveError');
        }
    }
}
